import { render, staticRenderFns } from "./StatusBar.vue?vue&type=template&id=366f954e&scoped=true&"
import script from "./StatusBar.vue?vue&type=script&lang=ts&"
export * from "./StatusBar.vue?vue&type=script&lang=ts&"
import style0 from "./StatusBar.vue?vue&type=style&index=0&id=366f954e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366f954e",
  null
  
)

export default component.exports